import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[mapTopBarButtonsItemHost]',
    standalone: false
})
export class MapTopBarButtonsItemHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
